import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { forkJoin, switchMap } from 'rxjs';
import { UserService } from './core/user/user.service';
import { OUService } from './modules/admin/ou/ou.service';
import { NavigationService } from './core/navigation/navigation.service';

export const initialDataResolver: ResolveFn<any> = () =>
{
    const navigationService = inject(NavigationService);
    const ouService = inject(OUService);
    const userService = inject(UserService);

    // Fork join multiple API endpoint calls to wait all of them to finish
    return ouService.retrieveOu()
        .pipe(switchMap(() => {
            return forkJoin([
                navigationService.get(),
                userService.get(),
            ]);
        }));
};
